import * as React from "react"

const TimelineSVG = (props) => (
	<svg width={19} height={19} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M18 3a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V5h-2a1 1 0 1 1 0-2h2V1a1 1 0 1 1 2 0v2h2Zm-2 14H2V3h5a1 1 0 0 0 0-2H2C.9 1 0 1.9 0 3v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5a1 1 0 1 0-2 0v5Zm-3-6a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm-5 3a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0v6Zm-3 1a1 1 0 0 0 1-1v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1Z"
			fill="currentColor"
		/>
	</svg>
)

export default TimelineSVG
